module.exports = __webpack_public_path__ + "assets/images/P-orange-icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/P-orange-icon.png
// module id = 242
// module chunks = 1